import React, { createContext, useState, useRef } from 'react';

const ErrorContext = createContext();

const ErrorProvider = ({ children }) => {
    const [type, setErrorType] = useState("error");
    const [displayError, setDisplayError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("An error occurred. Please try again later.");
    const [errorDuration, setErrorDuration] = useState(20000);

    return (
        <ErrorContext.Provider value={{
            type,
            setErrorType,
            displayError, 
            setDisplayError,
            errorMessage,
            setErrorMessage,
            errorDuration,
            setErrorDuration
        }}>
            {children}
        </ErrorContext.Provider>
    );
}

export { ErrorContext, ErrorProvider };
